import axios from 'axios';
import AuthententionService from '@zorgconnect/shared-portal/Modules/Authentication/Service';
import SessionService from '@zorgconnect/shared-portal/Modules/SessionService';

export const apiUrl = window.location.href.match('local.perfectstate.nl') ? "https://zf.local.perfectstate.nl" : "";
export const portalUrl = window.location.href.match('local.perfectstate.nl') ? "https://zp.local.perfectstate.nl" : "https://portal.zorgconnect.u-staat-centraal.nl";
// const apiUrl = "";
// import endpointConfiguration from 'Configuration';

const axiosConfig = {
    withCredentials: true
}

class EndpointService{

    constructor() {
        this.isPWA = false;
        const mqStandAlone = '(display-mode: standalone)';
        if(
            navigator?.standalone ||
            window.matchMedia(mqStandAlone).matches
        ) {
            this.isPWA = true;
        }
       
    }

    getCustomPWAConfig() {
        if(this.isPWA) {
            return {
                ...axiosConfig,
                headers: {
                    'PWA-Source': "zl",
                    'X-Tab-Id': SessionService.getClientId()
                }
            }
        } else {
            return {
                ...axiosConfig,
                headers: {
                    'X-Tab-Id': SessionService.getClientId()
                }
            };
        }
    }

    getCurrentPWAString() {
        return this.isPWA ? "zl" : "";
    }

    setIsPWA(value) {
        this.isPWA = value;
    }


    async get(url){
        let config = this.getCustomPWAConfig();
        let authorization = await AuthententionService.getAuthorizationToken();
        if(authorization) {
            config.headers = {
                ...config.headers,
                authorization: `Bearer ${authorization}`
            }
        }

        console.log("getting url", apiUrl + url);
        console.log("config", config);

        return axios.get(apiUrl + url, config);

    }

    async post(url, params){
        let config = this.getCustomPWAConfig();
        let authorization = await AuthententionService.getAuthorizationToken();
        if(authorization) {
            config.headers = {
                ...config.headers,
                authorization: `Bearer ${authorization}`
            }
        }

        console.log("getting url", apiUrl + url);
        console.log("config", config);
        return axios.post(apiUrl + url, params, config)

    }

    delete(url){
        // return axios.delete(url);
    }

    async put(url, params){
        let config = this.getCustomPWAConfig();
        let authorization = await AuthententionService.getAuthorizationToken();
        if(authorization) {
            config.headers = {
                ...config.headers,
                authorization: `Bearer ${authorization}`
            }
        }

        console.log("getting url", apiUrl + url);
        console.log("config", config);
        return axios.put(apiUrl + url, params, config);
    }

    processResult(response){
        // return response.data;
    }

    createDataProxy(entity){
        // return new DataProxy(entity);
    }
}

export default new EndpointService();
